import { ReturnIcon } from "@/assets/images/svgIcons/returnIcon"
import { Button } from "@/components/ui/baseUi/button"
import { cn } from "@/modules/lib/utils"
import { useCalendar } from "@modules/calendar/hooks/useCalendar"
import { word } from "@modules/core/utils/i18n"
import dayjs from "dayjs"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { Text } from "@/components/ui/baseUi/text"

export function BoxPlanningHeaderLeftView({ className, ...props }: React.ComponentProps<"div">) {
  const { currentWeekTitle, prev, next, selectedDate, setSelectedDate } = useCalendar()
  return (
    <div
      className={cn(
        "mb-5 flex h-50 flex-col justify-center gap-2 rounded-4xl bg-surface-foreground px-4 py-9 xl:px-9",
        className,
      )}
      {...props}
    >
      <div className="flex flex-row items-center justify-around text-center">
        <Button variant="ghost" size="iconMd" onClick={prev} className="hover:ring-0">
          <ChevronLeft size={24} />
        </Button>
        <Text fontStyle="TM">{currentWeekTitle}</Text>
        <Button variant="ghost" size="iconMd" onClick={next} className="hover:ring-0">
          <ChevronRight size={24} />
        </Button>
      </div>

      <Button
        variant="underline"
        className="mx-auto text-xs capitalize"
        size="sm"
        onClick={() => setSelectedDate(dayjs())}
        disabled={dayjs().isSame(selectedDate, "day")}
      >
        {word("global.today.label")}
        <ReturnIcon color={dayjs().isSame(selectedDate, "day") ? "var(--neutral-500)" : "var(--textDefault-body)"} />
      </Button>
    </div>
  )
}
